export default __webpack_public_path__ + "static/media/play-room-chill-room.943cb284.svg";